import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./MainLayout.css";

const INACTIVITY_LIMIT = 15 * 60 * 1000;
const WARNING_TIME = 14 * 60 * 1000;

const MainLayout = ({ handleLogout }) => {
  const navigate = useNavigate();
  const [showSessionWarning, setShowSessionWarning] = useState(false);
  useEffect(() => {
    let logoutTimer;
    let warningTimer;

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      setShowSessionWarning(false);
      warningTimer = setTimeout(() => setShowSessionWarning(true), WARNING_TIME);
      logoutTimer = setTimeout(() => {
        handleAutoLogout();
      }, INACTIVITY_LIMIT);
    };

    const handleAutoLogout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/login"); // Redirect to login
    };

    // Listen for user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer(); // Start initial timer

    return () => {
      // Cleanup event listeners on unmount
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [handleLogout, navigate]);

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="content">
        <Header handleLogout={handleLogout} />
        {showSessionWarning && <Alert variant="warning" className="session-warning mb-0">Your session will close in one minute due to inactivity. <Button size="sm" variant="warning" onClick={() => window.dispatchEvent(new Event("mousemove"))}>Stay signed in</Button></Alert>}
        <div className="page-content"><Outlet /></div>
      </div>
    </div>
  );
};

export default MainLayout;
